import { render, staticRenderFns } from "./AddTableAreaModal.vue?vue&type=template&id=ded394a0&scoped=true"
import script from "./AddTableAreaModal.vue?vue&type=script&lang=js"
export * from "./AddTableAreaModal.vue?vue&type=script&lang=js"
import style0 from "./AddTableAreaModal.vue?vue&type=style&index=0&id=ded394a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded394a0",
  null
  
)

export default component.exports